import * as PR from "../../prime-modules/index";
import Layout from "../../components/layout/Layout"
import Input from "../../components/form/Input";
import { Form, Formik } from "formik";
import { otpValidateSchema } from "../../utils/schema";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import {  verifyEmail } from "../../services/api";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useToast } from "../../context/ToastContext";
import { login, logout } from "../../store/auth.slice";

const initialValues = {
    otp: ''
}

const VerifyEmail = () => {
    const dispatch = useDispatch()
    const {showToast} = useToast()
    const {search, pathname} = useLocation();
    const {userData : userInfo} = useSelector(state=> state.auth);
    const {labels} = useSelector(state=>state.language?.activelang);
    const userId = new URLSearchParams(search).get('id');
    const toast = useRef(null);
    const navigate = useNavigate();

    useEffect(()=>{
       if(!userId) {
        navigate('/')
    }
    },[userId,navigate]);

    const {mutate,isLoading} = useMutation(verifyEmail.bind(null,`${pathname?.replace('-','')?.slice(1,pathname?.length)}`),{
        onSuccess: (o) =>{
        showToast("success",labels?.LBLN0284)
        setTimeout(() => {
         if(o?.email === userInfo?.email){
            dispatch(login({ ...userInfo,isEmailVerified:true }))
            navigate('/my-account')
         }else{
            dispatch(logout());
            navigate('/signin') 
         }
        },2000)
        },
        onError : o =>  showToast("error",o?.message)
    });
    
    const submitHanlder = ({otp:code}) => {
        mutate({userId,code});
    };
    

    return <Layout>
        <PR.Toast ref={toast} />
        <section className="signup-section">
            <div className="grid">
                <div className="col-12 text-center">
                    <h1>{labels?.LBLN0045}</h1>
                    <p>{labels?.LBLN0046}</p>
                    <div className="signup-wrapper">
                        {/* Form section starts here */}
                        <Formik initialValues={initialValues} validationSchema={otpValidateSchema} onSubmit={submitHanlder} >
                            <Form autoComplete="off" className="form-block">
                                <div className='grid'>
                                    <div className="col-12 md:col-12">
                                        <Input 
                                            id={'otp'}
                                            name="otp"
                                            autoComplete={false}
                                            feedback={false}
                                            type={'otp'} 
                                            otpLength={6}
                                            aria-describedby={'otp'}
                                            toggleMask
                                            placeholder={labels?.LBLN0048}
                                        />
                                    </div>
                                    {/* <div className="col-4">
                                        <PR.Button disabled={isLoadingResend||!!timer} style={{fontSize:16}} onClick={mutateResendOTP.bind(null,{email,device:'string'})} label={`Resend OTP ${timer}`} type='button' className="button button-secondary w-12 mt-2"/>
                                    </div> */}
                                    <div className="col-12">
                                        <PR.Button disabled={isLoading} label={labels?.LBLN0235} type='submit' className="signup-button w-12"/>
                                    </div>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
}
export default VerifyEmail;